function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "envelope_svg__clip-path"
}, React.createElement("path", {
  id: "envelope_svg__Path_172",
  d: "M19.314-368.25H2.69A2.714 2.714 0 000-365.518v11.537a2.714 2.714 0 002.69 2.732h16.62a2.714 2.714 0 002.69-2.733v-11.532a2.711 2.711 0 00-2.686-2.736z",
  className: "envelope_svg__cls-1",
  "data-name": "Path 172",
  transform: "translate(0 368.25)"
})), React.createElement("clipPath", {
  id: "envelope_svg__clip-path-2"
}, React.createElement("path", {
  id: "envelope_svg__Path_174",
  d: "M66.8-311.02l5.243-4.969a.662.662 0 00.044-.9.579.579 0 00-.847-.047l-7.23 6.858-1.41-1.322s-.009-.009-.009-.014a.9.9 0 00-.1-.089l-5.74-5.429a.576.576 0 00-.847.052.657.657 0 00.049.9l5.305 5.011-5.283 5.227a.661.661 0 00-.027.9.6.6 0 00.439.2.583.583 0 00.408-.169l5.363-5.3 1.455 1.374a.58.58 0 00.4.159.577.577 0 00.4-.164l1.495-1.416 5.332 5.354a.578.578 0 00.413.173.583.583 0 00.435-.2.661.661 0 00-.022-.9z",
  "data-name": "Path 174",
  transform: "translate(-55.752 317.098)",
  fill: "none"
})), React.createElement("style", null, ".envelope_svg__cls-1{fill:#e5bb64}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "envelope_svg__Group_454",
  "data-name": "Group 454",
  transform: "translate(26.415 367.872)"
}, React.createElement("g", {
  id: "envelope_svg__Group_457",
  "data-name": "Group 457",
  transform: "translate(-26.415 -367.872)"
}, React.createElement("g", {
  id: "envelope_svg__Group_455",
  "data-name": "Group 455",
  clipPath: "url(#envelope_svg__clip-path)"
}, React.createElement("path", {
  id: "envelope_svg__Path_171",
  d: "M-5-355.788h22.455v-17.462H-5z",
  className: "envelope_svg__cls-1",
  "data-name": "Path 171",
  transform: "translate(4.772 373.019)"
})), React.createElement("g", {
  id: "envelope_svg__Group_456",
  "data-name": "Group 456",
  transform: "translate(2.754 2.277)",
  clipPath: "url(#envelope_svg__clip-path-2)"
}, React.createElement("path", {
  id: "envelope_svg__Path_173",
  d: "M50.752-309.175h16.942V-322.1H50.752z",
  "data-name": "Path 173",
  transform: "translate(-50.974 321.863)",
  fill: "#fff"
}))));

var SvgEnvelope = function SvgEnvelope(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 17
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgEnvelope as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/envelope.svg
// module id = 2142
// module chunks = 0